import React from "react";
import $ from "jquery";
import { hideModal } from "../../util/FormatUtil";
import Overlay from "../Overlay";
import { sweetalert } from "../../App";
import { BiMoveVertical } from "react-icons/bi";
import FAQAPI from "../../network/FAQAPI";
import { FAQ } from "../../types/FAQ";

interface FAQSortState {
  items: FAQ[];
  showLoading: boolean;
  showSaveOrderButton: boolean;
}
interface FAQSortProps {
  faqs: FAQ[];
  onSaved?: () => void;
}

export class FAQSortModal extends React.Component<FAQSortProps, FAQSortState> {
  public dragItemRef;
  public dragOverItemRef;
  public static ID = "faqsort";

  constructor(props) {
    super(props);
    this.state = {
      items: [],
      showLoading: false,
      showSaveOrderButton: false,
    };
    this.dragItemRef = React.createRef();
    this.dragOverItemRef = React.createRef();
    this.saveOrder = this.saveOrder.bind(this);
  }

  componentDidMount() {
    $(`#${FAQSortModal.ID}`).on('shown.bs.modal', function () {
      $(document).off('focusin.modal');
    });
  }

  componentWillReceiveProps(nextProps: Readonly<FAQSortProps>) {
    // Only reseed when the FAQ list itself changes - any other parent re-render
    // would otherwise discard a reorder the user has in progress.
    if (nextProps.faqs === this.props.faqs) {
      return;
    }
    this.setState({ items: FAQSortModal.seedItems(nextProps.faqs), showSaveOrderButton: false });
  }

  // Copies of the parent's rows, in saved display order - the table the parent
  // renders can be sorted by any column, which is not the order being edited here.
  static seedItems(faqs: FAQ[]): FAQ[] {
    if (!faqs) {
      return [];
    }
    return faqs
      .map(f => ({ ...f }))
      .sort((a, b) => (a.DisplayOrder || 0) - (b.DisplayOrder || 0));
  }

  handleSort = () => {
    if (this.dragItemRef.current == null || this.dragOverItemRef.current == null) {
      return;
    }
    let _items = [...this.state.items];
    const draggedItemContent = _items.splice(this.dragItemRef.current, 1)[0];
    _items.splice(this.dragOverItemRef.current, 0, draggedItemContent);
    this.dragItemRef.current = null;
    this.dragOverItemRef.current = null;
    _items = _items.map((item, index) => ({ ...item, DisplayOrder: index + 1 }));
    this.setState({ items: _items, showSaveOrderButton: true });
  }

  saveOrder() {
    this.setState({ showLoading: true }, async () => {
      let response = await FAQAPI.updateSortOrder(this.state.items);
      if (!response.success) {
        let msg = response.reason ? response.reason : "Unable to update sort order at this time.";
        this.setState({ showLoading: false });
        return sweetalert.fire({ icon: 'error', title: "", text: msg });
      }
      sweetalert.fire({ icon: "success", title: "", text: "Sort order saved" }).then(() => {
        this.setState({ showLoading: false, showSaveOrderButton: false });
        hideModal(FAQSortModal.ID);
        if (this.props.onSaved) this.props.onSaved();
      });
    });
  }

  render() {
    return (
      <>
        <Overlay show_loading={this.state.showLoading} zIndex={100005} />
        <div className="modal fade form_modal" id={FAQSortModal.ID} tabIndex={-1} style={{ zIndex: 100003 }} role="dialog"
          aria-labelledby="faq_sort_modal_label"
          aria-hidden="true">
          <div className="modal-dialog modal-lg modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="faq_sort_modal_label">Sort FAQ Order</h5>
                <button style={{ outline: 'none' }} type="button" className="close" data-dismiss="modal" aria-label="Close"
                  onClick={() => this.setState({ items: FAQSortModal.seedItems(this.props.faqs), showSaveOrderButton: false })}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body m-3">
                <p className="text-muted">Drag rows to reorder how FAQs appear to users, then save.</p>
                {this.state.items.length > 0 ?
                  <table className="table">
                    <thead>
                      <tr>
                        <th scope='col' style={{ width: '10%' }}>Sort</th>
                        <th scope='col' style={{ width: '60%' }}>Question</th>
                        <th scope='col' style={{ width: '30%' }}>Category</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.items.map((faq, index) => {
                        return (
                          <tr
                            key={faq.ID}
                            draggable
                            style={{ cursor: 'grab' }}
                            onDragStart={() => this.dragItemRef.current = index}
                            onDragEnter={() => this.dragOverItemRef.current = index}
                            onDragEnd={this.handleSort}
                            onDragOver={(e) => e.preventDefault()}
                          >
                            <td><BiMoveVertical /></td>
                            <td>{faq.Question}</td>
                            <td>{faq.CategoryName ? faq.CategoryName : 'General'}</td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                  :
                  <div className="text-center text-bold" style={{ fontSize: '1.5rem' }}>No FAQs to display</div>
                }
              </div>
              <div className="modal-footer">
                <button type="button" className={this.state.showSaveOrderButton ? "btn btn-primary" : "invisible"} onClick={this.saveOrder}>
                  Save Order
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}
